import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { PropTypes } from 'prop-types'
import { COLOR_BLACK, COLOR_GRAY__400 } from '../../lib/colors'
import { Inter } from '../../lib/fonts'
import UIInputError from './UIInputError'

const UITextArea = ({
  dynamicStyle,
  placeholder,
  onChange,
  size,
  value,
  errorMessage,
  ...props
}) => {
  const isInError = !!errorMessage

  return (
    <div className={css(styles.container, dynamicStyle)}>
      <textarea
        placeholder={placeholder}
        className={css(styles.textarea, styles[size])}
        onChange={onChange}
        value={value}
        {...props}
      />
      {isInError && <UIInputError errorMessage={errorMessage} />}
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    margin: '10px 0',
  },
  textarea: {
    color: COLOR_BLACK,
    border: `1px solid ${COLOR_GRAY__400}`,
    borderRadius: 6,
    resize: 'none',
    fontFamily: [Inter, 'sans-serif'],
    padding: 10,
    width: '100%',
    height: '100%',
  },
  none: {
    width: '100%',
    height: '100%',
  },
  small: {
    width: '100%',
    height: 300,
  },
})

UITextArea.propTypes = {
  dynamicStyle: PropTypes.object,
  value: PropTypes.string,
  size: PropTypes.oneOf(['none', 'small']),
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  errorMessage: PropTypes.string,
}

export default UITextArea
